module.exports = "<div class=\"container\">\n  <h1>Home Page</h1>\n\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main